import { LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntity } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntity'

export const useFetchLegalEntityCommandById =
  LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntity.useSuspenseQuery
